import React from "react";

export type GradeType = "excellent" | "satisfactory" | "improvement";

export interface CardResultGradeProps {
  grade: GradeType;
  className?: string;
}

const gradeConfig = {
  excellent: {
    label: "우수",
    color: "#6d2ef2", // primary
  },
  satisfactory: {
    label: "보통",
    color: "#417af5", // system/news
  },
  improvement: {
    label: "노력",
    color: "#ff4084", // system/store
  },
};

const CardResultGrade: React.FC<CardResultGradeProps> = ({
  grade,
  className = "",
}) => {
  const config = gradeConfig[grade];

  return (
    <div
      className={`inline-flex items-center justify-start ${className}`}
      style={{ color: config.color }}
    >
      <span className="font-bold text-[14px] leading-[20px] tracking-[-0.28px]">
        {config.label}
      </span>
    </div>
  );
};

export default CardResultGrade;
